import { DropdownProps } from "antd";
import classNames from "classnames";
import { CSSProperties, useCallback, useLayoutEffect, useMemo, useRef, useState } from "react";

const DropdownPositionFix = ({ children }) => {
  const ref = useRef<HTMLDivElement>();
  const [parentHeight, setParentHeight] = useState("auto");

  const recalculate = useCallback(() => {
    const parent = ref.current?.parentElement;
    const parentRect = parent?.getBoundingClientRect();
    if (!parentRect) return;

    let nextHeight = "auto";
    if (parentRect.top < 0) {
      nextHeight = parentRect.height + parentRect.top - 2 + "px";
    } else if (parentRect.height + parentRect.top > window.innerHeight) {
      nextHeight = window.innerHeight - parentRect.top - 2 + "px";
    }

    setParentHeight((prev) => (prev === nextHeight ? prev : nextHeight));
  }, []);

  useLayoutEffect(() => {
    recalculate();
    const rafId = requestAnimationFrame(recalculate);
    return () => cancelAnimationFrame(rafId);
  }, [recalculate]);

  const style: CSSProperties = useMemo(
    () => ({
      position: "relative",
      height: parentHeight,
      overflowY: "auto",
      overflowX: "hidden",
    }),
    [parentHeight]
  );

  return (
    <div style={style} ref={ref} className={classNames("dropdown-position-fix")}>
      {children}
    </div>
  );
};

/**
 * This method fixes the cut-off on top of the screen items for the dropdown menu. 
Use it to position the dropdown menu inside of the viewport
 */
export const dropdownPositionFix: DropdownProps["popupRender"] = (originNode) => (
  <DropdownPositionFix>{originNode}</DropdownPositionFix>
);
